export default "__VITE_ASSET__ChUtam0f__"